var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7408 12.2308C12.6184 12.1908 11.8454 11.8423 12.3284 10.3738H12.3215C13.5808 9.07692 14.5431 6.99 14.5431 4.93538C14.5431 1.77615 12.4423 0.119995 10.0008 0.119995C7.55768 0.119995 5.46845 1.77538 5.46845 4.93538C5.46845 6.99846 6.42537 9.09384 7.69229 10.3877C8.18614 11.6831 7.30306 12.1638 7.11845 12.2315C4.56152 13.1561 1.56152 14.8415 1.56152 16.5054V17.1292C1.56152 19.3961 5.95691 19.9115 10.0246 19.9115C14.0984 19.9115 18.4384 19.3961 18.4384 17.1292V16.5054C18.4384 14.7915 15.4238 13.1192 12.7408 12.2308Z",
    fill: "#1D7E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook1);
export default __webpack_public_path__ + "static/media/book1.94183c3737939a25542f2ffa0d774639.svg";
export { ForwardRef as ReactComponent };